<template>
  <div class="main-end">
    <h4>
      <i class="el-icon-arrow-up"></i>
      メイン 終了
    </h4>
  </div>
</template>

<script>
export default {
  name: "MainEnd",
  props: {
    act: Object
  }
};
</script>
